import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const HorizontalArrowRightContainer = styled.div<{
  offset: number;
  vertical: boolean;
}>`
  background: rgba(0, 0, 0, 0.8);
  border-radius: ${Screen.widthRatio * 20}px;
  height: ${(props) => (props?.vertical ? 299 : 197) * Screen.widthRatio}px;
  left: ${(props) => Screen.widthRatio * props.offset}px;
  opacity: 0;
  padding-left: ${Screen.widthRatio * 29}px;
  position: relative;
  top: ${Screen.widthRatio * 4}px;
  width: ${Screen.widthRatio * 83}px;
  &:hover {
    opacity: 1;
  }
  & > svg {
    position: absolute;
    top: ${(props) => (props.vertical ? 115 : 64) * Screen.widthRatio}px;
    left: ${Screen.widthRatio * 27}px;
  }
`;

export default withAnimation(HorizontalArrowRightContainer);
